import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import 
{
  Container, Text, Card, FlagWrapper, FlagComponent, FlagBody, FormGroup, Display1, Body1, ProgressIndicator, ProgressSpinner
} from '@jsluna/react'
import { ArrowRight } from '@jsluna/icons'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import PassStatusCard from './PassStatusCard'
import api from '../../utils/api'
import stringHelpers from '../../utils/stringHelpers'

class Passes extends Component {
  constructor() {
    super()

    this.state = {
      sites: [],
      workOrders: [],
      selectedSite: null,
      loadingPassDetails: false,
      authorised: [],
      unauthorised: [],
      requireAction: [],
      wo1: {},
      wo2: {}
    }
  }

  componentWillMount = () => {
    const { assignments, workOrders } = this.props
    this.setState({ workOrders })
    try {
      this.dataLoad(assignments)
    } catch (e) {
      console.log(e)
    }
  }

  componentDidMount = () => {
    if (this.props.setMenu === true) {
      this.props.setMenuSelectedState({ selectedMenu: '/passes' })
    }
  }

  componentWillReceiveProps(newProps) {
    const { userChecked, workOrders } = this.props
    if (newProps.userChecked && newProps.userChecked !== userChecked) {
      this.dataLoad(newProps.assignments)
    }
    else {
      this.woLoad()
    }
    if (this.state.workOrders !== workOrders) {
      this.setState({ workOrders })
    }
  }

  dataLoad = (assignments) => {
    var sites = []
    const { loadPasses } = this.props

    if (assignments && assignments.length > 0) {
      if (assignments[0].locationCode) {
        loadPasses(stringHelpers.stripLettersFromString(assignments[0].locationCode))
        sites.push(stringHelpers.stripLettersFromString(assignments[0].locationCode))
      }
      if (assignments[0].secondaryLocationCode) {
        loadPasses(stringHelpers.stripLettersFromString(assignments[0].secondaryLocationCode))
        sites.push(stringHelpers.stripLettersFromString(assignments[0].secondaryLocationCode))
      }

      this.setState({ sites })

      if ( this.state.selectedSite === null ) {
        this.setState({ selectedSite: sites[0]}, this.woLoad)
      }
    }
  }

  woLoad = () => {
    const { selectedSite, workOrders } = this.state
    var selectedWO = workOrders.find(wo => wo.siteCode === selectedSite)
    const reqd = []
    const auth = []
    const unauth = []

    if (selectedWO && selectedWO.passesList) {
      selectedWO.passesList.forEach((wo) => {
        if (wo.actionRequired === 'Authorisation') {
          reqd.push(wo)
        }
        if (wo.actionRequired === 'Authorised') {
          auth.push(wo)
        }
        if (wo.actionRequired === 'UnAuthorised') {
          unauth.push(wo)
        }
      })
      selectedWO.passesList.forEach((wo) => {
        if (wo.actionRequired === 'Sign off') {
          reqd.push(wo)
        }
      })
    }
    this.setState({ requireAction: reqd, authorised: auth, unauthorised: unauth })
  }

  getPassDetails = (wo) => {
    const { history, setPassDetails } = this.props
    const Console = console
    this.setState({ loadingPassDetails: true })

    api.getPassDetailsAsync(wo.visitId)
      .then(res => res.map(passJson => JSON.parse(passJson)))
      .then(response => setPassDetails(response, wo.actionRequired))
      .then(() => history.push('/passes/passDetails'))
      .catch((error) => {
        Console.log(error)
        this.setState({ loadingPassDetails: false })
      })
  }

  displayWorkOrderInfo = (workOrder) => {
    if (workOrder) {
      return (
        <div>
          <FlagWrapper>
            <FlagComponent>
              <div className="ln-u-padding-left*2 ln-u-padding-bottom ln-u-padding-top">
                <Display1>{`Work order: ${workOrder.workOrderNumber}`}</Display1>
              </div>
            </FlagComponent>
            <FlagBody className="ln-u-text-align-right">
              <div className="ln-u-text-align-right">
              {moment.utc(workOrder.time).local().format('YYYY-MM-DD')}{' '}{moment.utc(workOrder.time).local().format('HH:mm')}
              </div>
            </FlagBody>
          </FlagWrapper>
          <div className="ln-u-padding-left*2 ln-u-padding-right">
            <div className="u-max-lines__two">{workOrder.description}</div>
            <PassStatusCard actionText={workOrder.actionRequired} />
          </div>
        </div>
      )
    }
    return null
  }

  showRequireActionWorkOrders = (wos) => {
    if (wos) {
      return wos.map(wo => (
        <div>
          {wo.actionRequired === 'Authorisation' && (
            <div key={wo.visitId} className="u-margin-bottom__small">
              <Card hard onClick={() => { this.getPassDetails(wo) }}>
                <div className="ln-u-padding-bottom*2">
                  <FlagWrapper className="ln-u-padding-top">
                    <FlagBody>
                      <div className="ln-u-padding-right">
                        <Body1>{this.displayWorkOrderInfo(wo)}</Body1>
                      </div>
                    </FlagBody>
                    <FlagComponent className="ln-u-text-align-right">
                      <div className="ln-u-padding-right">
                        <ArrowRight size="large" />
                      </div>
                    </FlagComponent>
                  </FlagWrapper>
                </div>
              </Card>
            </div>
          )}
          {wo.actionRequired === 'Sign off' && (
            <div key={wo.visitId} className="u-margin-bottom__small">
              <Card hard onClick={() => { this.getPassDetails(wo) }}>
                <div className="ln-u-padding-bottom*2">
                  <FlagWrapper className="ln-u-padding-top">
                    <FlagBody>
                      <div className="ln-u-padding-right">
                        <Body1>{this.displayWorkOrderInfo(wo)}</Body1>
                      </div>
                    </FlagBody>
                    <FlagComponent className="ln-u-text-align-right">
                      <div className="ln-u-padding-right">
                        <ArrowRight size="large" />
                      </div>
                    </FlagComponent>
                  </FlagWrapper>
                </div>
              </Card>
            </div>
          )}
        </div>
      ))
    }
    return null
  }

  showAuthorisedWorkOrders = (wos) => {
    if (wos) {
      return wos.map(wo => (
        <div>
          {wo.actionRequired === 'Authorised' && (
            <div key={wo.visitId} className="u-margin-bottom__small">
              <Card hard onClick={() => { this.getPassDetails(wo) }}>
                <div className="ln-u-padding-bottom*2">
                  <FlagWrapper className="ln-u-padding-top">
                    <FlagBody>
                      <div className="ln-u-padding-right">
                        <Body1>{this.displayWorkOrderInfo(wo)}</Body1>
                      </div>
                    </FlagBody>
                    <FlagComponent className="ln-u-text-align-right">
                      <div className="ln-u-padding-right">
                        <ArrowRight size="large" />
                      </div>
                    </FlagComponent>
                  </FlagWrapper>
                </div>
              </Card>
            </div>
          )}
        </div>
      ))
    }
    return null
  }

  showUnAuthorisedWorkOrders = (wos) => {
    // eslint-disable-next-line no-console
    //console.log('showUnAuthorisedWorkOrders');
    if (wos) {
      return wos.map(wo => (
        <div>
          {wo.actionRequired === 'UnAuthorised' && (
            <div key={wo.visitId} className="u-margin-bottom__small">
              <Card hard onClick={() => { this.getPassDetails(wo) }}>
                <div className="ln-u-padding-bottom*2">
                  <FlagWrapper className="ln-u-padding-top">
                    <FlagBody>
                      <div className="ln-u-padding-right">
                        <Body1>{this.displayWorkOrderInfo(wo)}</Body1>
                      </div>
                    </FlagBody>
                    <FlagComponent className="ln-u-text-align-right">
                      <div className="ln-u-padding-right">
                        <ArrowRight size="large" />
                      </div>
                    </FlagComponent>
                  </FlagWrapper>
                </div>
              </Card>
            </div>
          )}
        </div>
      ))
    }
  }

  showNoSiteError = () => (
    <FormGroup
      style={{ marginLeft: '27px' }}
      className="ln-u-soft-top u-device-padding"
      name="error"
      error={<span>No site assigned.</span>}
    >
      <span />
    </FormGroup>
  )

  handleSiteChange = (event, siteCode) => {
    event.preventDefault()
    if (this.state.selectedSite !== siteCode) {
      this.setState({ selectedSite: siteCode }, this.woLoad)
    }
  }

  getSiteTab = (siteCode) => {
    const isSiteSelected = this.state.selectedSite === siteCode ? 'is-active' : ''
    const classname = `${isSiteSelected} siteItem`
    return (
      <li key={siteCode}>
        <a href="" className={classname} onClick={(event) => this.handleSiteChange(event, siteCode)}>Store {siteCode}</a>
      </li>
    )
  }

  render() {
      const { loading, userChecked } = this.props
    const { loadingPassDetails, sites, selectedSite, workOrders, requireAction, authorised, unauthorised } = this.state
    var selectedWO = workOrders.find(wo => wo.siteCode === selectedSite)

    return (
      <div>
        <ProgressIndicator page loading={loadingPassDetails}>
          <ProgressSpinner />
          Getting pass details...
        </ProgressIndicator>
        <div className="ln-c-header-body" id="main-content">
          <Container size="xs">
            <div className="u-device-padding ln-u-padding-top*2">
              <h3> Passes</h3>
            </div>

            {sites === [] && userChecked
              && this.showNoSiteError()}
            
            {sites.length > 0 && 
              <ul className="siteNav">
                {sites.map(siteCode => this.getSiteTab(siteCode))}
              </ul>
            }
            <div className="u-device-padding ln-u-padding-top*4">
              <h6 className="requireAction">
                {' '}
                Requires action (
                {requireAction.length}
                )
              </h6>
            </div>
            {requireAction.length > 0 ?
              this.showRequireActionWorkOrders(selectedWO.passesList) : <Text className="requireActionMessage"> There are no items that need your attention</Text>}
            <div className="u-device-padding ln-u-padding-top*2">
              <h6 className="authorised">
                {' '}
                Authorised (
                {authorised.length}
                )
              </h6>
            </div>
            {authorised.length > 0 ?
              this.showAuthorisedWorkOrders(selectedWO.passesList) : <Text className="authorisedMessage"> There are no authorised work orders</Text>}
             <div className="u-device-padding ln-u-padding-top*2">
              <h6 className="unAuthorised">
                {' '}
                Unauthorised (
                {unauthorised.length}
                )
              </h6>
            </div>
            {unauthorised.length > 0 ?
              this.showUnAuthorisedWorkOrders(selectedWO.passesList) : <Text className="authorisedMessage"> There are no unauthorised work orders</Text>} 
          </Container>
          
          <ProgressIndicator page loading={loading}>
            <ProgressSpinner />
            Getting passes...
          </ProgressIndicator>
        </div>
      </div>
    )
  }
}

Passes.propTypes = {
  setMenuSelectedState: PropTypes.func.isRequired,
  setMenu: PropTypes.bool,
  loadPasses: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  workOrders: PropTypes.arrayOf(
    PropTypes.shape({
      workOrderNumber: PropTypes.string,
      actionRequired: PropTypes.string,
      description: PropTypes.string
    })
  ),
  siteCode: PropTypes.string,
  assignments: PropTypes.arrayOf(
    PropTypes.shape({
      jobGrade: PropTypes.string,
      locationCode: PropTypes.string,
      status: PropTypes.string,
    })
  ),
  userChecked: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  setPassDetails: PropTypes.func.isRequired,
}
Passes.defaultProps = {
  setMenu: false,
  siteCode: null
}
export default withRouter(Passes)


// WEBPACK FOOTER //
// ./src/components/Passes/Passes.jsx